/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_SubscriptionInputs */

const en_settings_billing_subscription = /** @type {(inputs: Settings_Billing_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Subscription`)
};

/**
* | output |
* | --- |
* | "Current Subscription" |
*
* @param {Settings_Billing_SubscriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscription = /** @type {((inputs?: Settings_Billing_SubscriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_SubscriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_subscription(inputs)
});
export { settings_billing_subscription as "settings.billing.subscription" }